import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import {passwordValidation} from "@app/utils/validation"

export const passwordSchema: FormFieldSchema[] = [
  {
    id: "password",
    noneStyle: true,
    type: FormFieldType.Group,
    schemas: [
      {
        id: "changePassword",
        label: "비밀번호 변경",
        noneStyle: true,
        type: FormFieldType.Group,
        schemas: [
          {
            id: "newPassword",
            label: "새로운 비밀번호",
            placeholder: "새로운 비밀번호를 입력해주세요.",
            type: FormFieldType.Password,
            validationFunction: (value) => passwordValidation.test(value),
            behavior: {
              required: true,
            },
          },
          {
            id: "confirmPassword",
            label: "비밀번호 확인",
            placeholder: "비밀번호를 다시 입력해주세요.",
            type: FormFieldType.Password,
            validationFunction: (value) => passwordValidation.test(value),
            behavior: {
              required: true,
            },
          },
        ],
      },
    ],
  },
];
